import { render } from "./ReadingNotes.vue?vue&type=template&id=28ee82ef"
import script from "./ReadingNotes.vue?vue&type=script&lang=js"
export * from "./ReadingNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__